module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-settings-selected@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Menus-betmenu/btn-settings-selected@3x.png
// module id = 574
// module chunks = 0